import React from 'react';
import {
  AppBadge,
  AppButton,
  AppFormField,
  AppInput,
  AppModal,
} from '../../ui';

function KlubMagazineCommercantEditModal({
  show,
  busy,
  form,
  onChangeForm,
  onClose,
  onSave,
}) {
  return (
    <AppModal
      show={show}
      title="Éditer le snapshot commerçant"
      onClose={onClose}
      size="lg"
      footer={(
        <>
          <AppButton variant="outline-secondary" onClick={onClose}>Annuler</AppButton>
          <AppButton variant="primary" loading={busy} onClick={onSave}>Enregistrer</AppButton>
        </>
      )}
    >
      <div className="row g-3">
        <div className="col-12">
          <AppBadge
            as="button"
            type="button"
            id="snap-nouveau"
            variant={form.is_nouveau ? 'success' : 'secondary'}
            pill
            className={`klub-magazine-nouveau-tag${form.is_nouveau ? ' is-active' : ''}`}
            aria-pressed={form.is_nouveau}
            onClick={() => onChangeForm((f) => ({ ...f, is_nouveau: !f.is_nouveau }))}
          >
            Nouveau
          </AppBadge>
        </div>
        <div className="col-md-6">
          <AppFormField label="Nom" htmlFor="snap-nom">
            <AppInput id="snap-nom" value={form.nom} onChange={(e) => onChangeForm((f) => ({ ...f, nom: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-md-6">
          <AppFormField label="Activité" htmlFor="snap-activite">
            <AppInput id="snap-activite" value={form.activite} onChange={(e) => onChangeForm((f) => ({ ...f, activite: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-md-6">
          <AppFormField label="Complément" htmlFor="snap-complement">
            <AppInput id="snap-complement" value={form.complement} onChange={(e) => onChangeForm((f) => ({ ...f, complement: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-md-6">
          <AppFormField label="Copyright" htmlFor="snap-copyright">
            <AppInput id="snap-copyright" value={form.copyright} onChange={(e) => onChangeForm((f) => ({ ...f, copyright: e.target.value }))} />
          </AppFormField>
        </div>
      </div>
    </AppModal>
  );
}

export default KlubMagazineCommercantEditModal;
